import styled from 'styled-components';
import { mdiDownload, mdiAlertCircleOutline } from '@mdi/js';
import Icon from '@mdi/react';

import { Flex, Box } from 'components';

export const Wrapper = styled.div`
  background: #0f0f0f;
`;

export const ContentWrapper = styled(Box)`
  margin: 0 auto;

  ${({ theme: { mediaQueries } }) => {
    return `
      ${mediaQueries.desktop} {
        max-width: 960px;
      }
    `;
  }}
`;

export const Header = styled.div`
  width: 100vw;
  background: url('/images/imersao/imersao-bg.jpg');
  background-size: cover;
  background-position: top right;

  ${({ theme: { mediaQueries } }) => {
    return `
      min-height: 400px;

      ${mediaQueries.desktop} {
        min-height: 840px;
      }
    `;
  }}
`;

export const Header2 = styled.div`
  width: 100vw;
`;

export const HeaderWrapper = styled.div`
  margin: 0 auto;

  ${({ theme: { mediaQueries } }) => {
    return `
    ${mediaQueries.desktop} {
      max-width: 1100px;
    }
  `;
  }}
`;

export const HeaderContent = styled.div`
  position: relative;
  background: rgba(46, 61, 60, 0.9);

  .gradient-content {
    position: relative;
    z-index: 3;
    color: $white;
    width: 100%;
  }

  &::after {
    display: block;
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 50%);
    opacity: 0.6;
  }

  ${({ theme: { mediaQueries } }) => {
    return `
      max-width: 100%;
      min-height: 400px;
      padding: 20px;

      ${mediaQueries.desktop} {
        max-width: 700px;
        min-height: 840px;
        padding: 60px;
      }
    `;
  }}
`;

export const HeaderContent2 = styled.div`
  position: relative;
  background: rgba(46, 61, 60, 0.9);

  .gradient-content {
    position: relative;
    z-index: 3;
    color: $white;
    width: 100%;
  }

  &::after {
    display: block;
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 50%);
    opacity: 0.6;
  }

  ${() => {
    return `
      max-width: 100%;
      padding: 40px;
    `;
  }}
`;

export const DownloadIcon = styled(Icon).attrs({
  path: mdiDownload,
})`
  display: block;
  color: ${({ theme }) => theme.colors.primary_400};
  &:hover {
    color: ${({ theme }) => theme.colors.primary_200};
  }
  ${({ theme: { mediaQueries } }) => {
    return `
      width: 2rem;
      height: 2rem;

      ${mediaQueries.desktop} {
        width: 2.2rem;
        height: 2.2rem;
      }
    `;
  }}
`;

export const AlertIcon = styled(Icon).attrs({
  path: mdiAlertCircleOutline,
})`
  display: block;
  color: ${({ theme }) => theme.colors.white};

  ${({ theme: { mediaQueries } }) => {
    return `
      width: 2rem;
      height: 2rem;

      ${mediaQueries.desktop} {
        width: 2.2rem;
        height: 2.2rem;
      }
    `;
  }}
`;

export const DocumentTypography = styled('a')`
  line-height: 1.2;
  color: ${(props) => props.theme.colors.primary_600};

  &:hover {
    text-decoration: underline;
  }
`;

export const Square = styled('div')`
  width: 2px;
  height: 65px;
  background: #424543;
  position: relative;

  &::before {
    content: '';
    display: block;
    width: 14px;
    height: 14px;
    background: #00bfbe;
    position: absolute;
    bottom: 0;
  }
`;

export const Square2 = styled(Square)`
  &::before {
    height: 40px;
  }
`;

export const TermsLink = styled('a')`
  color: white;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export const LinkButton = styled('a')`
  display: block;
  text-align: center;
  font-size: 1rem;
  font-weight: 700;
  color: white;
  padding: 10px 0;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.primary_400};

  text-transform: uppercase;

  :hover {
    background: ${({ theme }) => theme.colors.primary_200};
  }

  :active {
    background: ${({ theme }) => theme.colors.primary_600};
  }
`;

export const LinkButtonDisabled = styled('a')`
  display: block;
  text-align: center;
  font-size: 1rem;
  font-weight: 700;
  color: white;
  padding: 10px 0;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.gray_500};

  text-transform: uppercase;

  :hover {
    background: ${({ theme }) => theme.colors.gray_500};
  }

  :active {
    background: ${({ theme }) => theme.colors.gray_500};
  }
`;

export const PacoteWrapper = styled(Box)`
  border-top: 1px solid #2a2c2b;
`;

export const MobileBreak = styled.br`
  ${({ theme: { mediaQueries } }) => {
    return `
      display: none;

      ${mediaQueries.desktop} {
        display: block;
      }
    `;
  }}
`;

export const FlexDownload = styled(Flex)`
  ${({ theme: { mediaQueries } }) => {
    return `
      flex-direction: row;


      ${mediaQueries.desktop} {
        align-items: flex-start;
        flex-direction: column;
      }
    `;
  }}
`;

export const FormLabel = styled(Box)`
  color: white;
  font-size: 14px;
  text-transform: uppercase;
`;

export const FormErrorMessage = styled.div`
  color: ${(props: any) => props.theme.colors.alert_400};
  font-size: 12px;
  margin-top: 3px;
`;

const getWidth = (field: string) => {
  if (field === 'name') return `width: 400px;`;
  if (field === 'taxDocument') return `width: 350px;`;
  if (field === 'email') return `width: 460px;`;
  if (field === 'birthDate') return `width: 250px;`;
  if (field === 'number') return `width: 100px;`;

  return `100%`;
};

export const FormInput = styled.input`
  background: ${(props: any) => (props['data-error'] ? props.theme.colors.alert_400 : 'white')};
  color: ${(props: any) => (props['data-error'] ? 'white' : 'black')};
  border: 0;
  border-radius: 4px;
  outline: none;
  padding: 10px;

  ${(props: any) => {
    return `
      width: ${props['data-field'] === 'number' ? '100px' : '100%'};

      ${props.theme.mediaQueries.desktop} {
        ${getWidth(props['data-field'])};
      }
    `;
  }}
`;

export const Hr = styled('hr')`
  border: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.dark_150};
  margin-top: 30px;
  margin-bottom: 20px;
`;

export const FormSubmit = styled.button`
  border: 0;
  padding: 20px;
  outline: none;
  background: ${({ theme }) => theme.colors.primary_600};
  border-radius: 4px;
  cursor: pointer;
`;
